import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { AppLinkActions } from 'actions'

@createStore(alt)
export default class AppLinkStore {
  constructor() {
    this.state = {
      adhocUrl: '',
      errored: false
    }

    this.bindActions(AppLinkActions)
  }

  static displayName = 'AppLinkStore'

  setLink({ url }) {
    this.setState({ adhocUrl: url })
  }

  setErrored(errored) {
    this.setState({ errored })
  }
}



// WEBPACK FOOTER //
// ./app/stores/AppLinkStore.js